import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import PropTypes from "prop-types";
import DocumentsContainer from "features/document/edit/documents/components/DocumentsContainer";
import { useSelector, shallowEqual } from "react-redux";
import { loadContactModes } from "features/offer/edit/client/contactModes/actionCreators";
import { getEmail } from "features/offer/edit/client/contactModes/selectors";
const OfferDocumentsContainer = ({ documentId, siteId, history, onChangeActiveStep }) => {
  const onDocumentsHistoryClick = fileId => {
    onChangeActiveStep(-1);
    history.push(`/offers/${documentId}/${siteId}/documentHistory/${fileId}`);
  };

  const { offerNumber } = useSelector(state => state.currentOffer.header, shallowEqual);
  const { clientId } = useSelector(state => state.currentOffer?.header?.client, shallowEqual);
  const state = useSelector(state => state);
  const { loaded, email } = getEmail(state, clientId);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!loaded && clientId) dispatch(loadContactModes(documentId, siteId, clientId));
  }, [clientId, loaded, dispatch, documentId, siteId]);

  return (
    <DocumentsContainer
      documentId={documentId}
      siteId={siteId}
      documentNumber={offerNumber}
      onDocumentsHistoryClick={onDocumentsHistoryClick}
      clientDefaultEmail={email}
    />
  );
};

OfferDocumentsContainer.propTypes = {
  documentId: PropTypes.number.isRequired,
  siteId: PropTypes.number.isRequired,
  history: PropTypes.object.isRequired,
  onChangeActiveStep: PropTypes.func.isRequired
};

export default OfferDocumentsContainer;
